var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUpload(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 24,
    viewBox: "0 0 32 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.75 11.9502L15.15 7.5502C15.28 7.4252 15.575 7.2002 16 7.2002C16.425 7.2002 16.72 7.42355 16.8485 7.55175L21.2485 11.9517C21.7173 12.4205 21.7173 13.1797 21.2485 13.6487C20.7798 14.1177 20.0205 14.1175 19.5515 13.6487L17.2 11.2952V18.8002C17.2 19.4627 16.6625 20.0002 16 20.0002C15.3375 20.0002 14.8 19.4627 14.8 18.8002V11.2952L12.405 13.6052C11.9363 14.0739 11.177 14.0739 10.708 13.6052C10.239 13.1364 10.285 12.4202 10.75 11.9502Z",
    fill: "black",
    fillOpacity: 0.6
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.2 8.7998C27.2 9.40981 27.085 9.99481 26.88 10.5298C29.8 11.1198 32 13.7048 32 16.7998C32 20.3348 29.1345 23.1998 25.6 23.1998H7.2C3.225 23.1998 0 19.9748 0 15.9998C0 12.8598 2.01 10.1898 4.81015 9.20646C4.80962 9.19125 4.80908 9.176 4.80854 9.16073C4.8043 9.04105 4.8 8.91966 4.8 8.7998C4.8 4.3798 8.38 0.799805 12.8 0.799805C15.765 0.799805 18.35 2.4098 19.7345 4.8098C20.4955 4.2998 21.4155 3.9998 22.4 3.9998C25.05 3.9998 27.2 6.14981 27.2 8.7998ZM15.15 7.5498L10.75 11.9498C10.285 12.4198 10.239 13.1361 10.708 13.6048C11.177 14.0736 11.9363 14.0736 12.405 13.6048L14.8 11.2948V18.7998C14.8 19.4623 15.3375 19.9998 16 19.9998C16.6625 19.9998 17.2 19.4623 17.2 18.7998V11.2948L19.5515 13.6484C20.0205 14.1171 20.7798 14.1174 21.2485 13.6484C21.7173 13.1794 21.7173 12.4201 21.2485 11.9514L16.8485 7.55135C16.72 7.42315 16.425 7.1998 16 7.1998C15.575 7.1998 15.28 7.4248 15.15 7.5498Z",
    fill: "black",
    fillOpacity: 0.6
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.b57cb92ef015c6ec53ab9d2f9b231f3f.svg";
export { ForwardRef as ReactComponent };